window.SubscriptionFunnel.StepPlanSelection = {
  initialize(allowPrepaid) {
    const variants = variantsData;
    const {
      matchingThreeMonthVariant,
      matchingSixMonthVariant,
      matchingTwelveMonthVariant,
      threeMonthPrepaidPlan,
      sixMonthPrepaidPlan,
      twelveMonthPrepaidPlan,
    } = this.findMatchingVariantsAndPlans(variants);

    if (SubscriptionFunnel.FunnelUtilities.funnel_variant === "BNPL") {
      this.displayBNPLContent();
    } else if (SubscriptionFunnel.FunnelUtilities.funnel_variant === "TIERS") {
      // Only run this in tiered funnels
      this.displayTieredContent();

      // Add event listeners for both old and new commitment length radios
      document
        .querySelectorAll('input[name="commitmentLength"]')
        .forEach((radio) => {
          radio.addEventListener("change", () => {
            this.updatePricesAndSavingsForCommitmentLength();
          });
        });

      this.updatePricesAndSavingsForCommitmentLength();
      this.updatePlanTierImage();

      // Initialize default selections for both old and new structures
      const commitmentLengthSixMonths = document.getElementById(
        "commitment-length-6-months"
      );
      const commitmentLengthSixMonthsRedesign = document.getElementById(
        "commitment-length-6-months-redesign"
      );
      const commitmentLengthSixMonthsRedesignV2 = document.getElementById(
        "commitment-length-6-months-redesign-v2"
      );
      // Use a more specific selector depending on which plan step is active
      let planTierObsessed;
      if (window.tieredPlanStepRedesignTest === true) {
        planTierObsessed = document.querySelector('.tiered-plan-display-redesign #obsessed');
      } else if (window.tieredPlanStepRedesignTestV2 === true) {
        planTierObsessed = document.querySelector('.tiered-plan-display-redesign-v2 #obsessed-v2');
      } else {
        planTierObsessed = document.querySelector('.tiered-plan-display #obsessed');
      }
    }

    if (allowPrepaid && sixMonthPrepaidPlan && twelveMonthPrepaidPlan) {
      if (threeMonthPrepaidPlan) {
        this.displayMonthlyAndPrepaidPlanPricing(
          matchingThreeMonthVariant,
          threeMonthPrepaidPlan,
          3,
          "[data-three-month-prepaid-price]",
          "[data-three-month-prepaid-monthly-price]",
          "[data-three-month-prepaid-savings]",
          "[data-three-month-monthly-total-price]",
          "[data-three-month-percent-monthly-savings]",
          "[data-three-month-percent-prepaid-savings]"
        );
      }
      this.displayMonthlyAndPrepaidPlanPricing(
        matchingSixMonthVariant,
        sixMonthPrepaidPlan,
        6,
        "[data-six-month-prepaid-price]",
        "[data-six-month-prepaid-monthly-price]",
        "[data-six-month-prepaid-savings]",
        "[data-six-month-monthly-total-price]",
        "[data-six-month-percent-monthly-savings]",
        "[data-six-month-percent-prepaid-savings]",
        "[data-six-month-dollar-monthly-savings]"
      );
      this.displayMonthlyAndPrepaidPlanPricing(
        matchingTwelveMonthVariant,
        twelveMonthPrepaidPlan,
        12,
        "[data-twelve-month-prepaid-price]",
        "[data-twelve-month-prepaid-monthly-price]",
        "[data-twelve-month-prepaid-savings]",
        "[data-twelve-month-monthly-total-price]",
        "[data-twelve-month-percent-monthly-savings]",
        "[data-twelve-month-percent-prepaid-savings]",
        "[data-twelve-month-dollar-monthly-savings]"
      );
    } else {
      this.hidePrepaidOffer();
    }
  },

  findMatchingVariantsAndPlans(variants) {
    let matchingThreeMonthVariant = null;
    let matchingSixMonthVariant = null;
    let matchingTwelveMonthVariant = null;
    let threeMonthPrepaidPlan = null;
    let sixMonthPrepaidPlan = null;
    let twelveMonthPrepaidPlan = null;

    variants.forEach((variant) => {
      const expectedAssortment =
        SubscriptionFunnel.FunnelUtilities.promo_type === "FEXT"
          ? "Love + FREE Extra Toys: 3 Toys, 2 Treats, 1 Chew - Allergy Free"
          : "Love: 2 Toys, 2 Treats, 1 Chew - Allergy Free";

      if (
        variant.productLine === SubscriptionFunnel.FunnelUtilities.subscription_type &&
        variant.size === quizData.dogSize &&
        variant.assortment === expectedAssortment
      ) {
        if (variant.commitmentLength === 3) {
          matchingThreeMonthVariant = variant;
          threeMonthPrepaidPlan = this.findMatchingPlan(
            variant,
            "three_month_prepaid",
            3
          );
        } else if (variant.commitmentLength === 6) {
          matchingSixMonthVariant = variant;
          sixMonthPrepaidPlan = this.findMatchingPlan(
            variant,
            "six_month_prepaid",
            6
          );
        } else if (variant.commitmentLength === 12) {
          matchingTwelveMonthVariant = variant;
          twelveMonthPrepaidPlan = this.findMatchingPlan(
            variant,
            "twelve_month_prepaid",
            12
          );
        }
      }
    });

    return {
      matchingThreeMonthVariant,
      matchingSixMonthVariant,
      matchingTwelveMonthVariant,
      threeMonthPrepaidPlan,
      sixMonthPrepaidPlan,
      twelveMonthPrepaidPlan,
    };
  },

  findMatchingPlan(variant, prepaidKey, commitmentLength) {
    return variant.sellingPlans.find((plan) => {
      return (
        plan &&
        plan.name ===
          `delivered every 1 month, prepaid for ${commitmentLength} shipments` &&
        plan[prepaidKey]
      );
    });
  },

  displayMonthlyAndPrepaidPlanPricing(
    variant,
    prepaidPlan,
    commitmentLength,
    prepaidTotalPriceSelector,
    monthlyPriceSelector,
    totalSavingsSelector,
    monthlyTotalPriceSelector,
    monthlyPercentSavingsSelector,
    prepaidPercentSavingsSelector,
    monthlyDollarTotalSavingsSelector
  ) {
    if (!prepaidPlan) return;
    const oneMonthPlanPrice =
      parseFloat(
        document.querySelector(".one-mo-price-number")?.textContent.trim()
      ) || 0;
    const totalOneMonthPrice = oneMonthPlanPrice * commitmentLength;
    const totalMonthlyPrice = variant.price * commitmentLength;
    const totalPrepaidPrice = prepaidPlan.price;
    const monthlyPrepaidPrice = totalPrepaidPrice / commitmentLength;
    const monthlyPrepaidSavings = totalMonthlyPrice - totalPrepaidPrice;
    const percentSavingsMonthly = Math.round(
      ((totalOneMonthPrice - totalMonthlyPrice) / totalOneMonthPrice) * 100
    );
    const percentSavingsPrepaid = Math.round(
      ((totalOneMonthPrice - totalPrepaidPrice) / totalOneMonthPrice) * 100
    );
    const totalDollarSavingsMonthly = Math.round(
      (totalOneMonthPrice - totalMonthlyPrice) / 100
    );

    if (SubscriptionFunnel.FunnelUtilities.funnel_variant === "BNPL") {
      document.querySelectorAll(monthlyPercentSavingsSelector).forEach((el) => {
        el.textContent = percentSavingsMonthly;
      });

      document
        .querySelectorAll(monthlyDollarTotalSavingsSelector)
        .forEach((el) => {
          el.textContent = totalDollarSavingsMonthly;
        });
      
      if (commitmentLength === 3) {
        window.threeMonthPlanPriceDisplay = `$${Math.round(variant.price / 100)}`;
        window.threeMonthPrepaidPriceDisplay = `$${(
          totalPrepaidPrice / 100
        ).toFixed(2)}`;
      } else if (commitmentLength === 6) {
        window.sixMonthPlanPriceDisplay = `$${Math.round(variant.price / 100)}`;
        window.sixMonthPrepaidPriceDisplay = `$${(
          totalPrepaidPrice / 100
        ).toFixed(2)}`;
      } else if (commitmentLength === 12) {
        window.twelveMonthPlanPriceDisplay = `$${Math.round(
          variant.price / 100
        )}`;
        window.twelveMonthPrepaidPriceDisplay = `$${(
          totalPrepaidPrice / 100
        ).toFixed(2)}`;
      }
    } else {
      const el = document.querySelector(prepaidTotalPriceSelector);
      if (el) {
        if (SubscriptionFunnel.FunnelUtilities.promo_type === "CROCS") {
          el.textContent = `$${(totalPrepaidPrice / 100).toFixed(2)} Total`;
        } else {
          el.textContent = `$${(totalPrepaidPrice / 100).toFixed(2)}/${
            commitmentLength === 6
              ? "6 months"
              : commitmentLength === 3
              ? "3 months"
              : "year"
          }`;
        }
      }

      if (commitmentLength === 3) {
        window.threeMonthPlanPriceDisplay = `$${Math.round(variant.price / 100)}`;
        window.threeMonthPrepaidPriceDisplay = `$${(
          totalPrepaidPrice / 100
        ).toFixed(2)}`;
      } else if (commitmentLength === 6) {
        window.sixMonthPlanPriceDisplay = `$${Math.round(variant.price / 100)}`;
        window.sixMonthPrepaidPriceDisplay = `$${(
          totalPrepaidPrice / 100
        ).toFixed(2)}`;
      } else if (commitmentLength === 12) {
        window.twelveMonthPlanPriceDisplay = `$${Math.round(
          variant.price / 100
        )}`;
        window.twelveMonthPrepaidPriceDisplay = `$${(
          totalPrepaidPrice / 100
        ).toFixed(2)}`;
      }

      const monthlyEl = document.querySelector(monthlyPriceSelector);
      if (monthlyEl) {
        monthlyEl.textContent = `$${(monthlyPrepaidPrice / 100).toFixed(2)}/mo`;
      }

      const savingsEl = document.querySelector(totalSavingsSelector);
      if (savingsEl) {
        savingsEl.textContent = `SAVE $${(monthlyPrepaidSavings / 100).toFixed(2)}!`;
      }
    }
  },

  hidePrepaidOffer() {
    const el = document.querySelector('.toggle-container');
    if (el) {
      el.style.display = 'none';
    }
  },

  validateCommitmentLength() {
    if (SubscriptionFunnel.FunnelUtilities.funnel_variant === "TIERS") {
      // TIERS: require both plan tier AND commitment length
      const planRadio = document.querySelector(
        "#select-commitment-length .plan input:checked"
      );
      const planRadioRedesign = document.querySelector(
        "#select-commitment-length .tiered-plan-display-redesign input[name='planTier']:checked"
      );
      const planRadioRedesignV2 = document.querySelector(
        "#select-commitment-length .tiered-plan-display-redesign-v2 input[name='planTier']:checked"
      );
      const lengthRadio = document.querySelector(
        "#select-commitment-length .commitment-length-item input:checked"
      );
      const lengthRadioRedesign = document.querySelector(
        "#select-commitment-length .tiered-plan-display-redesign input[name='commitmentLength']:checked"
      );
      const lengthRadioRedesignV2 = document.querySelector(
        "#select-commitment-length .tiered-plan-display-redesign-v2 input[name='commitmentLength']:checked"
      );

      // Use either the old, redesign, or v2 structure
      const selectedPlanRadio = planRadio || planRadioRedesign || planRadioRedesignV2;
      const selectedLengthRadio = lengthRadio || lengthRadioRedesign || lengthRadioRedesignV2;

      if (!selectedPlanRadio || !selectedLengthRadio) {
        // show error
        const errorMessage = document.querySelector(
          "#select-commitment-length .form-input-text-error-message"
        );
        if (errorMessage) {
          errorMessage.classList.remove("display-none");
        }

        // highlight missing selection(s) for all structures
        if (!selectedPlanRadio) {
          document
            .querySelectorAll("#select-commitment-length .plan-option, #select-commitment-length .plan-tier-option")
            .forEach((el) => el.classList.add("card--error"));
        }
        if (!selectedLengthRadio) {
          document
            .querySelectorAll(
              "#select-commitment-length .commitment-length-option"
            )
            .forEach((el) => el.classList.add("card--error"));
        }

        return false;
      }

      // both selected → save and continue
      quizData.planTier = selectedPlanRadio.value;
      quizData.commitmentLength = selectedLengthRadio.value;
      SubscriptionFunnel.FunnelNavigation.nextStep();
    } else {
      const selectedOption = document.querySelector(
        `#select-commitment-length .plan input:checked`
      );

      if (!selectedOption) {
        document
          .querySelector(
            `#select-commitment-length .form-input-text-error-message`
          )
          .classList.remove("display-none");
        document
          .querySelectorAll("#select-commitment-length .plan-option")
          .forEach((el) => {
            el.classList.add("card--error");
          });
        return false;
      }

      quizData.commitmentLength = selectedOption.value;
      // 'Love' is currently the equivalent as a Base Kit
      quizData.planTier = 'love';

      SubscriptionFunnel.FunnelNavigation.nextStep();
    }
  },

  handlePrepayToggle(event) {
    const toggleContainer = document.querySelector(".toggle-container");
    const toggleTextMonthly = document.querySelector(".toggle-text-monthly");
    const toggleTextPrepaid = document.querySelector(".toggle-text-prepaid");
    const plansList = document.querySelector(".plans-list");
    const selectedPlan = this.getSelectedPlanOption();
    const oneMoPlanSelected = selectedPlan?.value === "1";
    const upfrobiContent = document.querySelectorAll(".upfrobi-content");
    const mobiContent = document.querySelectorAll(".mobi-content");
    const scoutsHonor = document.querySelector(".scouts-honor");
    const threeMonthPlan = document.querySelector(".three-month-plan");
    const sixMonthPlan = document.querySelector(".six-month-plan");
    const twelveMonthPlan = document.querySelector(".twelve-month-plan");
    let paymentOption;

    if (event.target.checked === false) {
      paymentOption = "monthly";
      toggleContainer.classList.remove("toggle-container-upfrobi");
      toggleTextMonthly.classList.add("toggle-text-active");
      toggleTextPrepaid.classList.remove("toggle-text-active");
      plansList.classList.remove("plans-list-upfrobi");
      scoutsHonor.classList.remove("scouts-honor-upfrobi");
      prepaidXtcPrice.forEach((el) => el.classList.remove("strike-through"));
      regularXtcPrice.forEach((el) => el.classList.add("display-none"));

      xtcDescriptions.forEach((el) => {
        el.innerHTML =
          SubscriptionFunnel.FunnelUtilities.subscription_type === "ALLTREATS"
            ? "Upgrade to our Dental Club and get an extra bag of tasty Bright dental chews in every box for only $12/month."
            : "Upgrade to our Extra Toy Club and get an additional premium toy in every box for only $9/month.";
      });

      mobiContent.forEach((el) =>
        el.classList.remove("display-none", "visibility-hidden")
      );
      upfrobiContent.forEach((el) =>
        el.classList.add("display-none", "visibility-hidden")
      );

      if (threeMonthPlan) {
        threeMonthPlan.classList.remove("plan-with-badge");
      }

      if (sixMonthPlan) {
        sixMonthPlan.classList.remove("plan-with-badge");
      }

      if (twelveMonthPlan) {
        twelveMonthPlan.classList.add("plan-with-badge");
      }

      quizData.prepaid = false;
    } else if (event.target.checked === true) {
      paymentOption = oneMoPlanSelected ? "monthly" : "prepaid";
      toggleContainer.classList.add("toggle-container-upfrobi");
      toggleTextPrepaid.classList.add("toggle-text-active");
      toggleTextMonthly.classList.remove("toggle-text-active");
      plansList.classList.add("plans-list-upfrobi");
      scoutsHonor.classList.add("scouts-honor-upfrobi");
      prepaidXtcPrice.forEach((el) => el.classList.add("strike-through"));
      regularXtcPrice.forEach((el) => el.classList.remove("display-none"));

      xtcDescriptions.forEach((el) => {
        el.innerHTML =
          "Upgrade to our Extra Toy Club and get an additional premium toy in every box for only $8.10/month.";
      });

      mobiContent.forEach((el) =>
        el.classList.add("display-none", "visibility-hidden")
      );
      upfrobiContent.forEach((el) =>
        el.classList.remove("display-none", "visibility-hidden")
      );

      if (threeMonthPlan) {
        threeMonthPlan.classList.add("plan-with-badge");
      }

      if (sixMonthPlan) {
        sixMonthPlan.classList.add("plan-with-badge");
      }

      if (twelveMonthPlan) {
        twelveMonthPlan.classList.remove("plan-with-badge");
      }

      quizData.prepaid = true;
    }

    SubscriptionFunnel.StepExtraToy.applyPrepaidToggleXtcUpdates(
      event,
      selectedPlan
    );

    const subscriberType = window.subscriberType;
    let params = {
      "Plan Selection Type": paymentOption,
      brand: SubscriptionFunnel.FunnelUtilities.subscription_type,
      promo: SubscriptionFunnel.FunnelUtilities.promo_type,
      "Play Subscription Collection Name":
        SubscriptionFunnel.FunnelUtilities.collection_name,
      subscriberType,
    };

    Shopify.analytics.publish("rudderstack_track", {
      eventName: "Plan Selection Type Toggle Clicked",
      eventData: params
    });
  },

  handlePlanSelectionClick(event) {
    const planElement = event.target;
    const planElementId = planElement.id.toLowerCase();
    const prepaidToggle = document.querySelector("#prepayCheckbox");
    const prepaidToggleOn = prepaidToggle?.checked || false;
    const upfrobiContent = document.querySelectorAll(".upfrobi-content");
    const isOneMoPlan = planElement.value === "1";
    const isPrepaidActive = prepaidToggleOn && !isOneMoPlan;
    const mobiContent = document.querySelectorAll(".mobi-content");
    const scoutsHonor = document.querySelector(".scouts-honor");
    let paymentOption;

    if (planElementId.includes("monthly" || !isPrepaidActive)) {
      paymentOption = "monthly";
      scoutsHonor.classList.remove("scouts-honor-upfrobi");
      mobiContent.forEach((el) =>
        el.classList.remove("display-none", "visibility-hidden")
      );
      upfrobiContent.forEach((el) =>
        el.classList.add("display-none", "visibility-hidden")
      );
      quizData.prepaid = false;
    } else if (planElementId.includes("prepaid") || isPrepaidActive) {
      paymentOption = "prepaid";
      scoutsHonor.classList.add("scouts-honor-upfrobi");
      mobiContent.forEach((el) =>
        el.classList.add("display-none", "visibility-hidden")
      );
      upfrobiContent.forEach((el) =>
        el.classList.remove("display-none", "visibility-hidden")
      );
      quizData.prepaid = true;
    }
  },

  getSelectedPlanOption() {
    return Array.from(document.querySelectorAll(".plans-native-radio")).find(
      (radio) => radio.checked
    );
  },

  updateTotalTodayDisplayV6(displayElement, price) {
    displayElement.textContent = ` - ${price}`;
  },

  displayBNPLContent() {
    const bnplPlanStepControl = document.querySelector(".test-prepaid-control");
    const bnplXtcStepControl = document.querySelector(".bnpl-test-control");

    const bnplPlanStepVariant = document.querySelector(".bnpl-plan-step");
    const bnplXtcStepVariant = document.querySelector(".bnpl-xtc-step");

    bnplPlanStepControl.classList.add("display-none");
    bnplPlanStepVariant.classList.remove("display-none");

    bnplXtcStepControl.classList.add("display-none");
    bnplXtcStepVariant.classList.remove("display-none");
  },

  // Plan Tiers
  displayTieredContent() {
    const defaultPlanStepContent = document.querySelector(
      ".test-prepaid-control"
    );

    const tieredPlanStepContent = document.querySelector(
      ".tiered-plan-display"
    );

    const tieredPlanStepContentRedesign = document.querySelector(
      ".tiered-plan-display-redesign"
    );

    const tieredPlanStepContentRedesignV2 = document.querySelector(
      ".tiered-plan-display-redesign-v2"
    );

    const treatNoAllergyCopy = document.querySelectorAll(
      ".plan-feature-item-treats-no-allergies"
    );
    const treatAllergyCopy = document.querySelectorAll(
      ".plan-feature-item-treats-allergies"
    );

    defaultPlanStepContent.classList.add("display-none");

    if (window.tieredPlanStepRedesignTest === true) {
      tieredPlanStepContentRedesign.classList.remove("display-none");
    } else if (window.tieredPlanStepRedesignTestV2 === true) {
      tieredPlanStepContentRedesignV2.classList.remove("display-none");
    } else {
      tieredPlanStepContent.classList.remove("display-none");
    }

    if (quizData.allergies) {
      treatAllergyCopy.forEach((el) => el.classList.remove("display-none"));
      treatNoAllergyCopy.forEach((el) => el.classList.add("display-none"));
    } else {
      treatAllergyCopy.forEach((el) => el.classList.add("display-none"));
      treatNoAllergyCopy.forEach((el) => el.classList.remove("display-none"));
    }
  },

  handlePlanTierSelectionClick(event) {
    selectedPlanTier = event.target.value;
    this.updatePlanTierImage(selectedPlanTier);
    this.updateRedesignMsrpValue();
    this.updateRedesignV2MsrpValue();
  },

  handleCommitmentLengthSelectionClick(event) {
    this.updatePricesAndSavingsForCommitmentLength();
  },

  updatePlanTierImage(selectedPlanTier = null) {
    let selectedPlanTierValue;

    if (selectedPlanTier) {
      selectedPlanTierValue = selectedPlanTier;
    } else if (quizData.planTier) {
      selectedPlanTierValue = quizData.planTier;
    } else {
      selectedPlanTierValue = "obsessed";
    }

    // Update images in all plan step variants
    const imgs = document.querySelectorAll(
      ".plan-contents-image-container img, .tiered-plan-display-redesign-v2 .box-includes-row img[data-plan-tier]"
    );

    imgs.forEach((img) => {
      const isMatch = img.dataset.planTier === selectedPlanTierValue;
      img.classList.toggle("display-none", !isMatch);
    });

    // Update box-includes-qty values for toys, treats, chews
    const qtyMap = {
      love: { toys: 2, treats: 2, chews: 1 },
      obsessed: { toys: 3, treats: 2, chews: 1 },
      "super-obsessed": { toys: 4, treats: 4, chews: 2 },
    };
    const selectedQty = qtyMap[selectedPlanTierValue] || qtyMap["obsessed"];
    const v2Container = document.querySelector('.tiered-plan-display-redesign-v2');
    if (v2Container) {
      Object.entries(selectedQty).forEach(([type, value]) => {
        const qtyEl = v2Container.querySelector(`.box-includes-qty[data-qty-type='${type}']`);
        if (qtyEl) qtyEl.textContent = value;
      });
      // Update chews label for singular/plural based on plan tier
      const chewsLabel = v2Container.querySelector(".box-includes-qty[data-qty-type='chews'] ~ .box-includes-label");
      if (chewsLabel) {
        chewsLabel.textContent = selectedPlanTierValue === "super-obsessed" ? "Chews" : "Chew";
      }
      // Update treats pill for allergy status
      const treatsPill = v2Container.querySelector(".box-includes-qty[data-qty-type='treats'] ~ .box-includes-pill");
      if (treatsPill) {
        treatsPill.textContent = quizData.allergies ? "Allergy-Free" : "All Natural";
      }
    }
  },

  updatePlanOptionFextSections(selectedLength) {
    const planOptionFextSections = document.querySelectorAll(
      ".tiered-plan-display .free-extra-toys-container"
    );

    if (selectedLength === "1") {
      planOptionFextSections.forEach((section) => {
        section.style.display = "none";
      });
    } else {
      planOptionFextSections.forEach((section) => {
        section.style.display = "flex";
      });
    }
  },

  updatePricesAndSavingsForCommitmentLength() {
    const selectedLength = this.getSelectedCommitmentLength();

    if (SubscriptionFunnel.FunnelUtilities.promo_type === "FEXT") {
      this.updatePlanOptionFextSections(selectedLength);
    }

    // Update prices for the original tiered-plan-display
    document
      .querySelectorAll(".tiered-plan-display .plan-option")
      .forEach((card) => {
        const wrapper = card.querySelector(".plan-price");
        const rawPriceStr =
          wrapper.getAttribute(`data-price-${selectedLength}`) || "";
        const msrpStr = wrapper.getAttribute("data-msrp") || "";

        // strip out any non-numeric chars (like "$")
        const price = parseFloat(rawPriceStr.replace(/[^0-9.]/g, "")) || 0;
        const msrp = parseFloat(msrpStr.replace(/[^0-9.]/g, "")) || 0;
        const savingsPercent =
          msrp > 0 && price > 0 ? Math.round(((msrp - price) / msrp) * 100) : 0;

        // update the displayed price
        const priceEl = card.querySelector(".new-price");
        if (priceEl) {
          priceEl.textContent = rawPriceStr ? `${rawPriceStr}/mo` : "";
        }

        // update the savings pill
        const saveEl = card.querySelector(".card-footer-save-badge-pill");
        if (saveEl) {
          saveEl.textContent =
            savingsPercent > 0 ? `SAVE ${savingsPercent}%` : "";
        }
      });

    // Update prices for the new tiered-plan-display-redesign
    document
      .querySelectorAll(".tiered-plan-display-redesign .plan-price")
      .forEach((wrapper) => {
        const rawPriceStr =
          wrapper.getAttribute(`data-price-${selectedLength}`) || "";
        const msrpStr = wrapper.getAttribute("data-msrp") || "";

        // strip out any non-numeric chars (like "$")
        const price = parseFloat(rawPriceStr.replace(/[^0-9.]/g, "")) || 0;
        const msrp = parseFloat(msrpStr.replace(/[^0-9.]/g, "")) || 0;
        const savingsPercent =
          msrp > 0 && price > 0 ? Math.round(((msrp - price) / msrp) * 100) : 0;

        // update the displayed price
        const priceEl = wrapper.querySelector(".new-price");
        if (priceEl) {
          priceEl.textContent = rawPriceStr ? `${rawPriceStr}/mo` : "";
        }

        // update the old price if it exists
        const oldPriceEl = wrapper.querySelector(".old-price");
        if (oldPriceEl && msrp > 0) {
          oldPriceEl.textContent = `$${msrp}`;
        }
      });

    // After updating prices, also update the redesign msrp value
    this.updateRedesignMsrpValue();
    this.updateRedesignV2MsrpValue();

    // Show/hide the promo gwp fext in the redesign based on commitment length
    const promoGwpFext = document.querySelector('.tiered-plan-display-redesign .promo.gwp.fext');
    if (promoGwpFext) {
      if (selectedLength === "1") {
        promoGwpFext.style.display = "none";
      } else {
        promoGwpFext.style.display = "";
      }
    }
  },

  getSelectedCommitmentLength() {
    // grab the checked radio, or default to "6"
    const checked = document.querySelector(
      'input[name="commitmentLength"]:checked'
    );

    if (checked) {
      return checked.value;
    } else if (quizData.commitmentLength) {
      return quizData.commitmentLength;
    } else {
      return "6";
    }
  },

  // Helper to update the $ value in the redesign's .plan-msrp-original span and .as-low-value
  updateRedesignMsrpValue() {
    // Only run if the redesign is visible
    const redesignContainer = document.querySelector('.tiered-plan-display-redesign');
    if (!redesignContainer || redesignContainer.classList.contains('display-none')) return;

    // Find the selected plan radio
    const selectedPlanRadio = redesignContainer.querySelector('input[name="planTier"]:checked');
    if (!selectedPlanRadio) return;

    // Find the corresponding plan row
    const selectedRow = selectedPlanRadio.closest('tr');
    if (!selectedRow) return;

    // Find the plan-price element in the label cell
    const planPrice = selectedRow.querySelector('.plan-price');
    if (!planPrice) return;

    // Get the msrp value
    const msrp = planPrice.getAttribute('data-msrp');
    if (msrp) {
      const msrpSpan = redesignContainer.querySelector('.plan-msrp-original');
      if (msrpSpan) {
        msrpSpan.textContent = `$${msrp} Value`;
      }
    }

    // Get the 12 month price for this plan
    const price12 = planPrice.getAttribute('data-price-12');
    if (price12) {
      const asLowValue = redesignContainer.querySelector('.as-low-value');
      if (asLowValue) {
        asLowValue.textContent = `${price12}/Month`;
      }
    }
  },

  updateRedesignV2MsrpValue() {
    // Only run if the v2 redesign is visible
    const redesignV2Container = document.querySelector('.tiered-plan-display-redesign-v2');
    if (!redesignV2Container || redesignV2Container.classList.contains('display-none')) return;

    // Find the selected plan radio
    const selectedPlanRadio = redesignV2Container.querySelector('input[name="planTier"]:checked');
    if (!selectedPlanRadio) return;

    // Find the corresponding plan-price in .value-callouts-container for the selected plan tier
    const planPrice = redesignV2Container.querySelector(`.value-callouts-container .plan-price[data-plan-tier="${selectedPlanRadio.value}"]`);
    if (!planPrice) return;

    // Get the msrp value
    const msrp = planPrice.getAttribute('data-msrp');
    if (msrp) {
      const msrpSpan = redesignV2Container.querySelector('.plan-msrp-original');
      if (msrpSpan) {
        msrpSpan.textContent = `$${msrp} Value`;
      }
    }

    // Get the price for the selected commitment length
    const selectedLength = this.getSelectedCommitmentLength();
    const price = planPrice.getAttribute(`data-price-${selectedLength}`);
    if (price) {
      const asLowValue = redesignV2Container.querySelector('.as-low-value');
      if (asLowValue) {
        asLowValue.textContent = `${price}/Month`;
      }
    }
  },
};
